<template>
  <div :class="`page-loading loading-position-${position} loading-${type}`" v-if="visible">
    <!-- <div class="page-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <span v-if="type !== 'icon'">{{ text || $t('com_table_loading') }}</span> -->
    <a-spin />
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: 'center',
    },
    type: {
      type: String,
      default: 'vertical', // vertical|horizontal|icon
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    this.visible = this.show;
  },
  watch: {
    show(val) {
      this.visible = val;
    },
    visible(val) {
      this.$emit('update:show', val);
    },
  },
};
</script>
<style lang="less" scoped>
.page-loading {
  display: block;
  text-align: center;
  z-index: 99;
  color: #666;
  width: auto;
  align-items: center;
  margin: 200px auto;
  font-size: 12px;

  &.loading-icon {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.loading-position-left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .page-spinner {
      margin: 0;
    }
  }

  &.loading-horizontal {
    flex-direction: row;
    align-items: center;
    span {
      margin-left: 40px;
    }
  }
}

.page-loading span {
  display: block;
  padding-top: 15px;
}
.page-spinner {
  display: inline-block;
  position: relative;
  transform: scale(0.35);
  padding-bottom: 20px;
  margin-left: -38px;
}
.page-spinner div {
  transform-origin: 40px 40px;
  animation: page-spinner 1.2s linear infinite;
}
.page-spinner div::after {
  content: ' ';
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 6px;
  height: 18px;
  border-radius: 20%;
  background: #489fb5;
}
.page-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.page-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.page-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.page-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.page-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.page-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.page-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.page-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.page-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.page-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.page-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.page-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes page-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
